<div class="bottom-sheet">
  <div class="bottom-sheet__header header">
    <h1 class="header__text">{{ data.label }}</h1>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="bottom-sheet__contents">
    <mat-radio-group class="radio-options" [value]="data.value" (change)="onSelectionChange($event)">
      @for (option of data.options; track identifyOption($index, option)) {
      <mat-radio-button class="radio-option" [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</div>
